module.exports = __webpack_public_path__ + "img/Veranza-44-min.9cfcc7f0.jpg";